<br>

<div class="card card-default">
    <div class="card-header title_size">
    <h2 class="card-title">Edit Product Details</h2>
    <div class="card-tools">
    <button type="button" class="btn btn-tool" data-card-widget="collapse">
    <i class="fas fa-minus"></i>
    </button>
    <button type="button" class="btn btn-tool" data-card-widget="remove">
    <i class="fas fa-times"></i>
    </button>
    </div>
    </div>
    
    <div class="card-body">

    <div class="row">
    <div class="col-md-6">

        <div class="form-group">
            <label>Product Code</label>
            <input type="text" [readonly]="true" class="form-control" [(ngModel)]="data.product_code">
            </div>
            <div class="form-group">
                <label>Product Description</label>
                <input type="text" class="form-control" [(ngModel)]="data.product_full_description">
            </div>
            
            <div class="form-group">
            <label>Product Brand</label>
            <select  #teams (change)="onSelected(teams.value)" class="form-control select2 select2-hidden-accessible" style="width: 100%;" data-select2-id="1" tabindex="-1" aria-hidden="true" [(ngModel)]="data.product_brand_name">
                <option selected="selected" data-select2-id="1">{{data.product_brand_name}}</option>
                <option *ngFor="let d of brandName" data-select2-id="2" [value]="d.brand_id">{{d.brand_name}}</option>
                <span class="select2-selection__arrow" role="presentation"><b role="presentation"></b></span>
                </select> 
            </div>

            <div class="form-group">
                <label>Product RFID</label>
                <input type="text" class="form-control"  [(ngModel)]="data.rf_id_code">
            </div>

            <div class="form-group">
                <label>Deviation</label>
                <input type="number" class="form-control"  [(ngModel)]="data.deviation">
            </div>
            
            <div class="form-group">
                <label>Folder</label>
                <input type="text" class="form-control" [readonly]="true" [(ngModel)]="data.folder">
            </div>
            <div class="form-group">
                <label>Price Level 1</label>
                <input type="number" class="form-control" [readonly]="true" [(ngModel)]="data.price_level_1">
            </div>
            <div class="form-group">
                <label>Accounting Price</label>
                <input type="number" class="form-control" [readonly]="true" [(ngModel)]="data.accounting_price">
            </div>
    
            <div class="form-group">
                <label>Al Quiz Std Price</label>
                <input type="number" class="form-control" [readonly]="true" [(ngModel)]="data.al_quiz_std_price">
            </div>
            <div class="form-group">
                <label>Dip Std Price</label>
                <input type="number" class="form-control" [readonly]="true" [(ngModel)]="data.dip_std_price">
            </div>
            <div class="form-group">
                <label>Rak Std Price</label>
                <input type="number" class="form-control" [readonly]="true" [(ngModel)]="data.rak_std_price">
            </div>
            <div class="form-group">
                <label>Sharjah Std Price</label>
                <input type="number" class="form-control" [readonly]="true" [(ngModel)]="data.shj_std_price">
            </div>
            <div class="form-group">
                <label>Product UOM Main</label>
                <input type="text" class="form-control"   [(ngModel)]="data.product_uom_main">
            </div>
      
    </div>
    <!---------------------------------------------next row-------------------------------------->
    <div class="col-md-6">

        <div class="form-group">
            <label>Product Name</label>
            <input type="text" class="form-control" [(ngModel)]="data.product_name">
        </div>
        <div class="form-group">
            <label>Product SUK</label>
            <input type="text" class="form-control" [(ngModel)]="data.product_sku">
        </div>
<!----
        <div class="form-group">
            <label>Product Category Id</label>
            <input type="text" class="form-control" [readonly]="true" [(ngModel)]="data.product_category_id">
        </div>
 --->
        <div class="form-group">
            <label>Product Category Name</label>
            <input type="text" class="form-control"  [(ngModel)]="data.product_category_name">
        </div>
   
        <div class="form-group">
            <label>Shan's App Folder</label>
            <select  #team1 (change)="onSelectedFolder(team1.value)" class="form-control select2 select2-hidden-accessible" style="width: 100%;" data-select2-id="1" tabindex="-1" aria-hidden="true" [(ngModel)]="data.shansapp_folder">
                <option selected="selected" data-select2-id="1">{{data.shansapp_folder}}</option>
                <option *ngFor="let d of folderName" data-select2-id="2" [value]="d.folder_name">{{d.folder_name}}</option>
                <span class="select2-selection__arrow" role="presentation"><b role="presentation"></b></span>
            </select> 
            
        </div>



        <div class="form-group">
            <label>Total Stock</label>
            <input type="number" class="form-control" [(ngModel)]="data.stock">
        </div>
        <div class="form-group">
            <label>Test Price</label>
            <input type="number" class="form-control" [readonly]="true" [(ngModel)]="data.test">
        </div>
        <div class="form-group">
            <label>Abu Dhabhi Std Price</label>
            <input type="number" class="form-control" [readonly]="true" [(ngModel)]="data.abudhabi_std_price">
        </div>
        
        <div class="form-group">
            <label>Al Ain Std Price</label>
            <input type="number" class="form-control" [readonly]="true" [(ngModel)]="data.al_ain_std_price">
        </div>
        <div class="form-group">
            <label>Aweer Std Price</label>
            <input type="number" class="form-control" [readonly]="true" [(ngModel)]="data.aweer_std_price">
        </div>
    
        <div class="form-group">
            <label>Qusais Std Price</label>
            <input type="number" class="form-control" [readonly]="true" [(ngModel)]="data.qusais_std_price">
        </div>
  
        <div class="form-group">
            <label>Sajaa Std Price</label>
            <input type="number" class="form-control" [readonly]="true"  [(ngModel)]="data.sajaa_std_price">
        </div>
    
    </div>
    </div>
    <div class="form-group">
        <label>Video Link</label><br>
        <a [routerLink]="" (click)="goToLink(link)" class="look">{{link}}</a><span class="close1" (click)="Close();">{{close}}</span><br>
        <input #value type="text" class="form-control top" [(ngModel)]="data.video_link" (change)="ChangeVideo(value);">
    </div>
    <div class="form-group">
        <label>Technical Document</label><span class="error">{{SizeMessage}}</span><br>
        <a [routerLink]="" (click)="goToLink(document)" class="look">{{document}}</a>
        <span class="close1" (click)="Close1();">{{close1}}</span>
        <button class="btn  btn-sm c_left" (click)="copyMessage(document)" *ngIf="btnShown" value="click to copy" >Copy</button>
        <br>
       <!----
        <div class="custom-file top">
        <input #imageInput type="file" class="custom-file-input" id="customFile"  (change)="ProcessVideoFile(imageInput)" >
        <label class="custom-file-label" for="customFile">{{data.technical_document}}</label>
        </div>
        ---->

        <input #imageInput type="file" class="ctrl" (change)="ProcessVideoFile(imageInput)">
       
    <!-------------------------------------------------------------------------------->
    </div>
    <!-------------------loader----------------------------------->
    <div *ngIf=isLoader class="loader"></div>
    <!-------------------Test alert---------------------->
    <div class="alert alert-success alert-dismissible alertWidth" *ngIf="isShown">
        <button type="button" class="close" data-dismiss="alert" aria-hidden="true" (click)="shown()">×</button>
        <h4><i class="icon fas fa-check"></i> {{alert}}</h4>    
    </div>

    <button type="submit" class="btn btn-primary btn_allign" (click)="btnClick(); notification();">Submit</button>
    
    </div>
